import Vue from "vue";

const baseUrl = "/dna-budgets";

export async function indexByLead(leadId) {
  return Vue.prototype.$http.get(`${baseUrl}/leads/${leadId}`);
}

export async function show(id) {
  return Vue.prototype.$http.get(`${baseUrl}/${id}`);
}

export async function store(payload) {
  return Vue.prototype.$http.post(`${baseUrl}`, payload);
}

export async function destroy(id) {
  return Vue.prototype.$http.delete(`${baseUrl}/${id}`);
}

export async function accept(id) {
  return Vue.prototype.$http.post(`${baseUrl}/${id}/accept`);
}

export async function deny(id) {
  return Vue.prototype.$http.post(`${baseUrl}/${id}/deny`);
}

export async function finish(id, payload) {
  return Vue.prototype.$http.post(`${baseUrl}/${id}/finish`, payload);
}
